module.exports = __webpack_public_path__ + "img/slide19_vn.22187cdb.jpg";